<div class="asset-filter">
  <div class="asset-filter--header">
    <h2 class="asset-filter--title">
      Filters
      <span class="asset-filter--count" *ngIf="config.activeFilterCount > 0">
        {{ config.activeFilterCount }}
      </span>
    </h2>
    <button class="asset-filter--reset" (click)="onReset()" *ngIf="config.activeFilterCount > 0">
      Reset
    </button>
  </div>

  <!-- Filter Sections -->
  <div class="asset-filter--sections">
    <ng-container *ngFor="let section of config.sections">
      <div class="asset-filter--section" *ngIf="section.id !== 'bookmarks'">
        <button class="asset-filter--section-header" (click)="toggleSection(section.id)"
          [attr.aria-expanded]="section.isExpanded">
          <div class="asset-filter--section-title-wrapper">
            <img *ngIf="(section.icon || section.id === 'last-updated') && section.id !== 'bookmarks'"
              [src]="section.id === 'last-updated' ? '/filters/calendar.svg' : section.icon" alt=""
              class="asset-filter--section-icon" />
            <svg *ngIf="section.id === 'bookmarks' && isLoggedIn" class="asset-filter--section-icon" width="20"
              height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg *ngIf="section.id === 'bookmarks' && !isLoggedIn"
              class="asset-filter--section-icon asset-filter--lock-icon" width="20" height="20" viewBox="0 0 24 24"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="asset-filter--section-title">{{ section.title }}</span>
          </div>
          <svg *ngIf="!(section.id === 'bookmarks' && !isLoggedIn)" class="asset-filter--section-arrow"
            [class.expanded]="section.isExpanded" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>

        <div class="asset-filter--section-content" *ngIf="section.isExpanded" (click)="$event.stopPropagation()">
          <!-- Search within section -->
          <div class="asset-filter--section-search" *ngIf="section.type === 'checkbox' && section.searchPlaceholder">
            <input type="text" class="asset-filter--section-search-input" [placeholder]="section.searchPlaceholder"
              [(ngModel)]="section.searchQuery" />
            <img src="/filters/search-normal.svg" alt="Search" class="asset-filter--section-search-icon" />
          </div>


          <!-- Date range options -->
          <!-- Checkbox options: visual span shows checkmark (input::after doesn't render in browsers) -->
          <div class="asset-filter--options" *ngIf="section.type === 'checkbox' && section.options">
            <label class="asset-filter--option" *ngFor="let option of getFilteredOptions(section)">
              <span class="asset-filter--input-wrap">
                <input type="checkbox" class="asset-filter--checkbox-input" [checked]="option.checked"
                  (click)="onCheckboxClick($event, section.id, option.id)" />
                <span class="checkbox-checkmark-custom asset-filter--checkbox-visual"
                  [class.checked]="option.checked"></span>
              </span>
              <span class="asset-filter--option-label">{{ option.label }}</span>
            </label>
          </div>

          <!-- Radio options: visual span shows checkmark (input::after doesn't render in browsers) -->
          <div class="asset-filter--options" *ngIf="section.type === 'radio' && section.options">
            <label class="asset-filter--option" *ngFor="let option of section.options; let i = index">
              <span class="asset-filter--input-wrap">
                <input type="radio" class="asset-filter--radio-input" [name]="section.id" [checked]="option.checked"
                  [attr.checked]="option.checked ? 'checked' : null"
                  (click)="onRadioClick(section.id, option.id, $event, i)" #radioInput />
                <span class="checkbox-checkmark-custom asset-filter--radio-visual"
                  [class.checked]="option.checked"></span>
              </span>
              <span class="asset-filter--option-label">{{ option.label }}</span>
            </label>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>